/*
  The base Upward loading animation
  the one with three dots with blue and orange.

  takes in size as parameter - full resizeable

  size : small and large.
  if no size specified it defaults to medium

  No need to specify medium

  this loader always to be small size wherever used
*/
import React from 'react';

class UpwardLoader extends React.Component {
   constructor(props) {
      super(props);
   }

   render() {
      return (
         <div className='loading in'>
            <div className='spinner small' >
               <div className='bounce1' />
               <div className='bounce2' />
               <div className='bounce3' />
               <div className='bounce4' />
            </div>
         </div >
      );
   }
}

export default UpwardLoader;
